import { createAction, props } from '@ngrx/store';

import { type PendingActionTarget } from '@blaze-dashboard/ai-chat-domain';

export const pendingActionTargetRecorded = createAction(
  '[AI Chat] Pending action target recorded',
  props<{ target: PendingActionTarget }>(),
);

export const pendingActionTargetConsumed = createAction('[AI Chat] Pending action target consumed');
